import React from "react";
import { BULAN } from "@/lib/api";

const YEAR_NOW = new Date().getFullYear();
const YEARS = [YEAR_NOW - 1, YEAR_NOW, YEAR_NOW + 1];

export function FilterBar({ filters, setFilters, fields, onApply, onReset, dataTestidPrefix = "filter" }) {
  return (
    <section className="pp-card p-5 mb-6">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {fields.map((f) => (
          <FilterField key={f.key} field={f} value={filters[f.key] || ""} onChange={(v) => setFilters({ ...filters, [f.key]: v })} testid={`${dataTestidPrefix}-${f.key}`} />
        ))}
        <div className="flex gap-2 sm:col-span-2 lg:col-auto">
          <button onClick={onApply} className="pp-btn-primary flex-1" data-testid={`${dataTestidPrefix}-apply`}>Terapkan</button>
          <button onClick={onReset} className="pp-btn-secondary flex-1" data-testid={`${dataTestidPrefix}-reset`}>Reset</button>
        </div>
      </div>
    </section>
  );
}

function FilterField({ field, value, onChange, testid }) {
  if (field.type === "tanggal") {
    return (
      <label className="flex flex-col gap-1">
        <span className="text-xs font-medium text-slate-600">{field.label}</span>
        <input type="date" className="pp-input" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid} />
      </label>
    );
  }
  if (field.type === "bulan") {
    return (
      <select className="pp-input" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
        <option value="">Semua Bulan</option>
        {BULAN.map((b) => <option key={b.v} value={b.v}>{b.label}</option>)}
      </select>
    );
  }
  if (field.type === "tahun") {
    return (
      <select className="pp-input" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
        <option value="">Semua Tahun</option>
        {(field.years || YEARS).map((y) => <option key={y} value={y}>{y}</option>)}
      </select>
    );
  }
  if (field.type === "select") {
    return (
      <select className="pp-input" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
        <option value="">{field.placeholder || `Semua ${field.label}`}</option>
        {field.options.map((o) => (typeof o === "string" ? <option key={o} value={o}>{o}</option> : <option key={o.v} value={o.v}>{o.label}</option>))}
      </select>
    );
  }
  return <input className="pp-input" value={value} onChange={(e) => onChange(e.target.value)} placeholder={field.placeholder || field.label} data-testid={testid} />;
}
